<section class="container-nm px-4 pt-4 w-100 mx-auto step_mobile" style="box-sizing: border-box;">
    
    <div class="title-page">
        <span>{{ 'list.txtTilte' | translate }}</span>
    </div>
    <div class="line"></div>
    <div class="description-page d-flex align-items-center justify-content-center gap-3">
        <div class="block-field-search d-flex align-items-center" style="flex: 1 0 auto;">
            @if(showInput()){
                <mat-form-field appearance="outline" class="w-100 field-search" >
                    <input matInput placeholder="{{ 'list.txtFieldSearch' | translate }}"
                    #input 
                    [formControl]="control"
                    (input)="filter()"
                    (focus)="filter()"
                    [matAutocomplete]="auto">
                    @if(!iconChange){
                        <mat-icon matSuffix>search</mat-icon>
                    }@else{
                        <mat-icon matSuffix style="cursor: pointer;" (click)="clearFilter()">close</mat-icon>                        
                    }
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" classList="custom-panel-class another-class">
                        @for (room of filteredOptions | async; track room) {
                        <mat-option [value]="room.name">{{room.name}}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            }@else {
                <mat-form-field appearance="outline" class="w-100 field-search" style="opacity: 20%;pointer-events: none;">
                    <input matInput placeholder="{{ 'list.txtFieldSearch' | translate }}"
                    #input 
                    >
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            }
            
        </div>
        <!-- <div class="block-my-game d-flex align-items-center justify-content-end">
            <mat-checkbox class="game-player w-100" [(ngModel)]="checked" (click)="updateList()">{{ 'list.txtOnlyMyGame' | translate }}</mat-checkbox>
        </div> -->
    </div>

    <div class="description-pages">
    <app-list-game style="width: 100%;" [game]="game()" [isSearch]="isListEmpty"></app-list-game>
        <!-- <app-create-game style="width: 80%;"></app-create-game> -->
    </div>

    <div class="d-flex justify-content-between align-items-center px-4375 my-23125">
            <div class="d-flex justify-content-start align-items-center w-100 mobile-step-1">
                <div class="d-flex justify-content-start align-items-center left-complex-button" [ngClass]="statysMobile()" (click)="goToPrev()">
                    
                        <button matIconButton class="example-icon d-flex justify-content-center align-items-center">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.83325 15.8333V14.1666H11.7499C12.6249 14.1666 13.3853 13.8888 14.0312 13.3333C14.677 12.7777 14.9999 12.0833 14.9999 11.2499C14.9999 10.4166 14.677 9.72214 14.0312 9.16659C13.3853 8.61103 12.6249 8.33325 11.7499 8.33325H6.49992L8.66658 10.4999L7.49992 11.6666L3.33325 7.49992L7.49992 3.33325L8.66658 4.49992L6.49992 6.66659H11.7499C13.0971 6.66659 14.2534 7.10409 15.2187 7.97909C16.1839 8.85409 16.6666 9.94436 16.6666 11.2499C16.6666 12.5555 16.1839 13.6458 15.2187 14.5208C14.2534 15.3958 13.0971 15.8333 11.7499 15.8333H5.83325Z" fill="#262626"/>
                            </svg>
                        </button>
                    <!-- }@else {
                        <button matIconButton class="example-icon d-flex justify-content-center align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="none">
                                <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" fill="#9A9A9A"/>
                            </svg>
                        </button>
                    } -->
                    
                    <span class="sub-button-title">{{ 'buttons.txtBack' | translate }}</span>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center w-100 mobile-step-2"></div>
            <div class="d-flex justify-content-end align-items-center w-100 mobile-step-3"></div>
    </div>
</section>

